exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-buttons button[data-v-71f57a30]{padding-left:25px;padding-right:25px;min-height:40px;border-radius:20px;color:#fff}.change-image[data-v-71f57a30],.upload-image[data-v-71f57a30]{background:-webkit-linear-gradient(left,#5b86e5,#36d1dc);background:-o-linear-gradient(right,#5b86e5,#36d1dc);background:-moz-linear-gradient(right,#5b86e5,#36d1dc);background:linear-gradient(90deg,#5b86e5,#36d1dc)}.remove-image[data-v-71f57a30]{background:-webkit-linear-gradient(left,#ef629f,#eecda3);background:-o-linear-gradient(right,#ef629f,#eecda3);background:-moz-linear-gradient(right,#ef629f,#eecda3);background:linear-gradient(90deg,#ef629f,#eecda3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71f57a30","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/fields/uploader.vue
// module id = 77
// module chunks = 0